
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'SectionTitle'
})
export default class SectionTitleComponent extends Vue {}
